import React, { useState, useEffect } from 'react';
import { View, ScrollView, TouchableOpacity, Alert } from "react-native"

import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import { Ionicons } from "@expo/vector-icons"
import * as Linking from 'expo-linking';

import { useForm } from "react-hook-form";
import Input from '../../components/Forms/Input';
import Button from '../../components/Forms/Button';
import { SafeAreaView } from 'react-native-safe-area-context';



function TicketForm(){
  const { control, handleSubmit, formState, formState: { errors }, setError, setValue, reset } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ticketSent, setTicketSent] = useState(false);


  function sendSupportTicket(data) {
    setIsSubmitting(true)

    setTimeout(() => {
      setTicketSent(true)
    }, 1000)
  }

  return (
    <View>
      {
        !ticketSent ?
          <View style={tw`bg-gray-50 rounded-xl p-4 pt-8`}>
            <Input
              name="name"
              control={control}
              rules={{ required: "Nombre Requerido" }}
              label="Tu Nombre"
              style={{ container: tw`flex-1`, input: tw`text-gray-400`, label: tw`bg-transparent font-normal ml-1 -mt-5 text-gray-400` }}
            />

            <Input
              name="email"
              control={control}
              keyboardType={"email-address"}
              label="Correo electrónico"
              rules={{ pattern: { value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Dirección de correo no válida" } }}
              style={{ container: tw`flex-1 mt-4`, input: tw`text-gray-400`, label: tw`bg-transparent font-normal ml-1 -mt-5 text-gray-400` }}
            />

            <Input
              name="message"
              control={control}
              label="Tu mensaje"
              multiline
              numberOfLines={3}
              style={{ container: tw`flex-1 mt-4`, input: tw`text-gray-400`, label: tw`bg-transparent font-normal ml-1 -mt-5 text-gray-400` }}
            />

            <Button
              label={!isSubmitting ? "Enviar" : "Enviando..."}
              disabled={isSubmitting}
              onPress={handleSubmit(sendSupportTicket)}
              style={{ container: tw`mt-4` }}
            />
          </View>
          :
          <Text style={tw`text-gray-400 mt-10 text-lg`}>Gracias por tu mensaje. Estaremos revisando tu mensaje y te contactaremos a la brevedad posible.</Text>
      }
    </View>
  )
}


function DeleteAccountForm(){
  const { control, handleSubmit, formState, formState: { errors }, setError, setValue, reset } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deletionSent, setDeletionSent] = useState(false);


  function sendAccountDeletion(data) {
    setIsSubmitting(true)

    setTimeout(() => {
      setDeletionSent(true)
    }, 1000)
  }

  function confirmDeletion(){
    Alert.alert('¿Eliminar tu cuenta?', 'Esta acción no puede ser revertida', [
      {
        text: 'Cancelar',
        onPress: () => { },
        style: 'cancel',
      },
      { text: 'Eliminar', onPress: handleSubmit(sendAccountDeletion)},
    ]);
  }

  return (
    <View>
      <Text style={tw`text-gray-600 text-lg text-center mb-4`}>Eliminar mi cuenta</Text>

      {
        ! deletionSent &&
          <>
            <Text style={tw`text-gray-500 mb-3`}>Si deseas eliminar tu cuenta, te podemos ayudar en el proceso. Al eliminar tu cuenta borraremos todos tus datos personales así como la información relacionada a tu cuenta</Text>
            <Text style={tw`text-gray-500`}>Este proceso puede tardar de 1 a 2 días hábiles. Esta acción no se puede revertir</Text>

            <Input
              name="message"
              control={control}
              label="Motivo de cancelación (opcional)"
              multiline
              numberOfLines={3}
              style={{ container: tw`flex-1 mt-10`, input: tw`text-gray-400`, label: tw`bg-transparent font-normal ml-1 -mt-5 text-gray-400` }}
            />

            <Button
              label={!isSubmitting ? "Eliminar mi cuenta" : "Enviando..."}
              disabled={isSubmitting}
              onPress={confirmDeletion}
              style={{ container: tw`mb-8 mt-5` }}
            />
          </>
      }

      {
        deletionSent &&
          <Text style={tw`text-center`}>Hemos recibido tu solicitud, el proceso de eliminación puede tardar de 1 a 2 días hábiles.</Text>
      }
    </View>
  )
}


export default function SupportScreen({ }) {
  const [showDeleteAccountForm, setShowDeleteAccountForm] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  return (
    <ScrollView contentContainerStyle={tw`px-4 py-6`}>
      <Text style={tw`text-gray-600 text-lg font-600 mb-2`}>Centro de Ayuda</Text>
      <Text style={tw`text-gray-500 mb-6`}>Encuentra respuestas a las preguntas más frecuentes o contáctanos directamente.</Text>

      {/* Knowledge Base */}
      <TouchableOpacity
        onPress={() => Linking.openURL('https://soporte.ding-dong.mx/residentes/')}
        style={tw`bg-primary/5 border border-primary/20 rounded-xl p-4 mb-4`}
      >
        <View style={tw`row items-center`}>
          <View style={tw`bg-primary/10 rounded-full p-3 mr-4`}>
            <Ionicons name='book-outline' size={24} color={tw.color('primary')} />
          </View>
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-700 font-600 text-base`}>Base de conocimiento</Text>
            <Text style={tw`text-gray-500 text-sm`}>Guías, tutoriales y preguntas frecuentes</Text>
          </View>
          <Ionicons name='chevron-forward' size={20} color={tw.color('gray-400')} />
        </View>
      </TouchableOpacity>

      {/* WhatsApp */}
      <TouchableOpacity
        onPress={() => Linking.openURL('https://wa.me/525539967392')}
        style={tw`bg-green-50 border border-green-200 rounded-xl p-4 mb-4`}
      >
        <View style={tw`row items-center`}>
          <View style={tw`bg-green-100 rounded-full p-3 mr-4`}>
            <Ionicons name='logo-whatsapp' size={24} color={"#25D366"} />
          </View>
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-700 font-600 text-base`}>WhatsApp</Text>
            <Text style={tw`text-gray-500 text-sm`}>Respuesta rápida en horario de oficina</Text>
          </View>
          <Ionicons name='chevron-forward' size={20} color={tw.color('gray-400')} />
        </View>
      </TouchableOpacity>

      {/* Formulario de contacto colapsable */}
      <TouchableOpacity
        onPress={() => setShowContactForm(!showContactForm)}
        style={tw`bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4`}
      >
        <View style={tw`row items-center`}>
          <View style={tw`bg-gray-100 rounded-full p-3 mr-4`}>
            <Ionicons name='mail-outline' size={24} color={tw.color('gray-500')} />
          </View>
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-700 font-600 text-base`}>Envíanos un mensaje</Text>
            <Text style={tw`text-gray-500 text-sm`}>Te responderemos por correo electrónico</Text>
          </View>
          <Ionicons name={showContactForm ? 'chevron-up' : 'chevron-down'} size={20} color={tw.color('gray-400')} />
        </View>
      </TouchableOpacity>

      {showContactForm && !showDeleteAccountForm && <TicketForm />}

      {/* Separador */}
      <View style={tw`border-t border-gray-200 my-6`} />

      {/* Eliminar cuenta */}
      {
        showDeleteAccountForm ?
          <DeleteAccountForm />
        :
          <TouchableOpacity onPress={() => setShowDeleteAccountForm(true)} style={tw`py-2`}>
            <Text style={tw`text-red-400 text-center`}>Eliminar mi cuenta</Text>
          </TouchableOpacity>
      }
    </ScrollView>
  )
}